import { render, staticRenderFns } from "./TipoMedicamento.vue?vue&type=template&id=6416cf63&scoped=true&"
import script from "./TipoMedicamento.vue?vue&type=script&lang=js&"
export * from "./TipoMedicamento.vue?vue&type=script&lang=js&"
import style0 from "./TipoMedicamento.vue?vue&type=style&index=0&id=6416cf63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6416cf63",
  null
  
)

export default component.exports